import React from "react";
import { useDialog } from "./DialogProvider";
import MissingDialog from "./MissingDialog";

const GlobalReminderDialog = () => {
    const { dialogType, dialogData, hideDialog } = useDialog();

    if (dialogType !== "reminders") return null;

    return <MissingDialog toggle={hideDialog} {...dialogData} />;
};

export default GlobalReminderDialog;
